/**
 * Strings of «Об'єкти», the object screen «Огляд» and «Налаштування»
 * (iteration 2, TZ-UI, texts of mockups/app-prototype.html).
 * Merged into `MESSAGES` (messages.ts); Ukrainian defines the key set.
 * Values: «назва → значення → одиниця», numbers in full, no dashes —
 * a short reason instead.
 */
export const SITE_MESSAGES = {
  en: {
    'sites.title': 'Objects',
    'sites.add': 'Add object',
    'sites.empty.title': 'No objects yet',
    'sites.empty.sub': 'Add a Deye inverter by the SN on its label — no DeyeCloud sign-in is needed.',
    'site.card.soc': 'charge',
    'site.card.no_data': 'no data yet',

    'site.conn.ok': 'Online',
    'site.conn.ok_at': 'Online · data as of {time}',
    'site.conn.off': 'No connection since {time}',
    'site.conn.never': 'No data yet',
    'site.conn.pending': 'Waiting for access',
    'site.conn.closed': 'Access closed',
    'site.conn.noedit': 'View only',
    'site.card.pending': 'Waiting for Phage.Energy access',
    'site.card.closed': 'Phage.Energy access closed',
    'site.card.noedit': 'View only',
    'site.conn.down': 'DeyeCloud not responding since {time}',
    'site.connnote.off':
      'The inverter has sent no data since {time}. The program already written to the inverter keeps running. Check the inverter power and the logger Wi-Fi.',
    'site.connnote.never': 'No measurements yet: the first one comes within a few minutes after connecting.',
    'site.connnote.pending':
      'We do not see this station in the Phage.Energy account yet, so there is no data and no control. Open the access in DeyeCloud: station → «Manage Access» → «+Add» → «{name}» → «Can edit» or «Can manage».',
    'site.connnote.closed':
      'Access for Phage.Energy is closed in DeyeCloud. Data download and arbitrage are stopped. Without access the inverter program cannot change: today’s program runs to the end of the day. To continue, open the access again.',
    'site.connnote.noedit':
      'Access is open with «Only view»: the data comes, the calculation is ready. For Phage to control the battery — «I want control».',
    'site.connnote.down':
      'DeyeCloud has not responded since {time}. We retry every 5 minutes. The program in the inverter keeps running.',

    'site.chip.region': 'Region',
    'site.chip.osr': 'DSO',
    'site.chip.tariff': 'Tariff',
    'site.chip.pv': 'PV',
    'site.chip.pv_kw': '{kw} kW',
    'site.chip.pv_yes': 'yes',
    'site.chip.pv_no': 'none',
    'site.chip.hist': 'History',
    'site.chip.arb': 'Internal arbitrage',
    'site.arb.on_short': 'on',
    'site.arb.off_short': 'off',
    'site.arb.stopped': 'stopped',
    'site.tariff.dam': 'day-ahead prices',
    'site.tariff.zone2': 'two-zone',
    'site.tariff.zone3': 'three-zone',
    'site.tariff.fixed': 'fixed',
    'site.tariff.none': 'not set',
    'site.model': '{model} · SN {sn}',
    'site.model.size': 'battery {cap} kWh · inverter {p} kW',
    'site.tabs': 'Object sections',
    'site.tab.overview': 'Overview',
    'site.tab.settings': 'Settings',

    'site.hist.done': '{days} days loaded',
    'site.hist.loading': 'loading: {done} of {total} days',
    'site.hist.pending': 'queued for download',
    'site.hist.few.one': 'little data: {n} day',
    'site.hist.few.few': 'little data: {n} days',
    'site.hist.few.many': 'little data: {n} days',
    'site.hist.few.other': 'little data: {n} days',
    'site.hist.error': 'download failed',
    'site.histnote.loading':
      'Downloading the history from DeyeCloud: {done} of {total} days. The consumption profile and the potential appear once there are 30 complete days.',
    'site.histnote.few.one':
      'Little data: {n} complete day of the 30 needed. The external arbitrage potential is not calculated yet; the profile uses the days available.',
    'site.histnote.few.few':
      'Little data: {n} complete days of the 30 needed. The external arbitrage potential is not calculated yet; the profile uses the days available.',
    'site.histnote.few.many':
      'Little data: {n} complete days of the 30 needed. The external arbitrage potential is not calculated yet; the profile uses the days available.',
    'site.histnote.few.other':
      'Little data: {n} complete days of the 30 needed. The external arbitrage potential is not calculated yet; the profile uses the days available.',
    'site.histnote.error':
      'The history was not downloaded: DeyeCloud did not answer. We retry automatically in an hour.',
    'site.histnote.retry': 'Retry now',
    'site.histnote.queued': 'Queued: the download starts within a minute.',
    'site.histnote.no_access': 'Without Phage.Energy access to the station the history cannot be downloaded.',

    'site.now.title': 'Now',
    'site.now.at': 'data as of {time}',
    'site.now.last': 'last data {time}',
    'site.now.none': 'No measurements yet: the first one comes within a few minutes after connecting.',
    'site.now.no_access': 'No data: Phage.Energy access to the station is not open.',
    'site.now.soc': 'Battery charge',
    'site.now.soc_min': 'minimum charge {pct} %',
    'site.now.battery': 'Battery',
    'site.now.grid': 'Grid',
    'site.now.pv': 'PV',
    'site.now.load': 'Consumption',
    'site.now.charge': 'charge',
    'site.now.discharge': 'discharge',
    'site.now.idle': 'idle',
    'site.now.buy': 'import',
    'site.now.sell': 'export',
    'site.now.no_exchange': 'no exchange',
    'site.now.generation': 'generation',
    'site.now.object_load': "object's load",
    'site.now.no_value': 'not measured',
    'site.unit.kw': 'kW',

    'site.money.title': 'Money',
    'site.money.days.one': '{n} day',
    'site.money.days.few': '{n} days',
    'site.money.days.many': '{n} days',
    'site.money.days.other': '{n} days',
    'site.money.sub': '{days} · {from}–{to} · tariff {tariff}',
    'site.money.tariff.zone': '{name}: {rates} ₴/kWh',
    'site.money.zone.night': 'night',
    'site.money.zone.day': 'day',
    'site.money.zone.peak': 'peak',
    'site.money.zone.half': 'half-peak',
    'site.money.at.night': 'at night',
    'site.money.at.day': 'by day',
    'site.money.at.peak': 'at peak',
    'site.money.at.half': 'at half-peak',
    'site.money.actual': 'Electricity costs',
    'site.money.arb': 'With internal arbitrage, estimate',
    'site.money.diff': 'Difference',
    'site.money.arb.model': 'If Phage controlled the battery — model',
    'site.money.diff.model': 'Saving potential',
    'site.money.model.note':
      'Control is off: this is a model over the same days, within your inverter’s limits.',
    'site.arb.model.title': 'Model over {days}: {from}–{to}',
    'site.arb.model.how': 'How it is calculated',
    'site.arb.model.how.load':
      'Consumption — your actual one by hour over these days, from DeyeCloud; it repeats with small deviations.',
    'site.arb.model.how.battery':
      'Battery {capacity} kWh, {floor}–{max} %, efficiency {etaCharge} × {etaDischarge}; the installer’s limits: discharge up to {power} kW, grid charge up to {grid} kW.',
    'site.arb.model.how.battery_no_grid':
      'Battery {capacity} kWh, {floor}–{max} %, efficiency {etaCharge} × {etaDischarge}; the installer’s limits: discharge up to {power} kW, no grid charge.',
    'site.arb.model.how.edges':
      'Start — the battery’s actual charge at the beginning of the period, end — its actual charge at the end; the difference in charge — at the mean price of the last day.',
    'site.money.how.zones': 'bought {parts}',
    'site.money.how.part': '{kwh} kWh {zone} × {rate}',
    'site.money.how.dam': 'bought {kwh} kWh × mean price {price} ₴/kWh',
    'site.money.how.arb':
      "the same {days}, your consumption and the inverter's own use by hour, your tariff; the battery follows the internal arbitrage schedule",
    'site.money.fixed': 'Fixed tariff: internal arbitrage does not apply.',
    'site.money.pv': 'Saving by PV',
    'site.money.how.pv': 'produced {produced} − exported {exported} = {self} kWh',
    'site.money.how.pv_dam': ' × mean price {price} ₴/kWh',
    'site.money.how.diff': 'costs − estimate with internal arbitrage',
    'site.money.no_rate': 'the fixed tariff rate is not set',
    'site.money.no_tariff': 'Sums are calculated at your tariff — choose it in the settings.',
    'site.money.no_history': 'Appears after the history download.',
    'site.money.no_prices': 'No day-ahead prices for the days of the history.',
    'site.data.restored':
      'Restored hours: {hours} — the inverter sent no samples in them; the energy between the samples is spread over them by time.',
    'site.energy.title': 'Energy',
    'site.energy.sub': 'complete days in local time',
    'site.energy.unit': 'kWh',
    'site.energy.day': 'Day {date}',
    'site.energy.month': '30 days, complete days {days}',
    'site.energy.load': 'Consumed',
    'site.energy.pv': 'PV generated',
    'site.energy.import': 'Bought from the grid',
    'site.energy.export': 'Sent to the grid',
    'site.energy.charge': 'Battery charge',
    'site.energy.discharge': 'Battery discharge',
    'site.energy.none': 'Statistics appear after the history download.',
    'site.energy.legend.load': 'Consumed',
    'site.energy.legend.pv': 'PV',
    'site.energy.explain':
      "Sent to the grid — energy that left the object for the grid through the connection point (the inverter's meter). Battery discharge — energy from the battery into the object's consumption.",

    'site.profile.title': 'Consumption profile',
    'site.profile.edit': 'Adjust manually',
    'site.profile.note.auto':
      "Built automatically from the object's history: median by hour over {days} days ({from}–{to}), {total} kWh a day in total. Used in the internal arbitrage plan. Recalculated daily after the previous day is downloaded.",
    'site.profile.note.manual':
      'Set manually: {total} kWh a day in total. Used in the internal arbitrage plan instead of the automatic profile.',
    'site.profile.none':
      'The profile appears once there is consumption history. You can also set it manually.',
    'site.profile.legend.median': 'Median, kW',
    'site.profile.legend.manual': 'Set manually, kW',
    'site.profile.legend.spread': 'Spread of days, 10–90 %',
    'site.profile.edit.sub':
      'Average consumption per hour, kW. Manual values apply until you return to the automatic profile.',
    'site.profile.save': 'Save profile',
    'site.profile.reset': 'Return to automatic',
    'site.profile.saved': 'Profile saved.',
    'site.profile.reset_done': 'Automatic profile restored.',
    'site.profile.err': 'Values are numbers from 0, kW.',
    'site.profile.hour': '{h}',

    'site.arb.title': 'Internal arbitrage',
    'site.arb.on': 'On',
    'site.arb.off': 'Off',
    'site.arb.sub':
      'day {date} · grid charge in cheap hours, discharge into own consumption in expensive ones; the battery does not export',
    'site.arb.no_access_disabled': 'Not switchable without Phage.Energy access to the station.',
    'site.arb.no_original':
      "The inverter's original settings are not stored — no program is written to the inverter until they are.",
    'site.arb.orig_saved':
      "The inverter's original settings are stored ({at}) — they go back when switched off.",
    'site.arb.what.title': 'What the installation does today',
    'site.arb.what.charge': 'Charge from the grid',
    'site.arb.what.discharge': 'The battery covers the consumption',
    'site.arb.what.reserve': 'Reserve for an outage',
    'site.arb.what.none': 'none',
    'site.arb.what.soc': 'to {soc} %',
    'site.arb.what.max_reserve': 'maximum — {soc} %',
    'site.arb.switch_err': 'Could not switch: {msg}',
    'site.zero_current.charge':
      "In the inverter's settings the charge current is 0 A — the battery does not charge. Change it in DeyeCloud: Battery Setting.",
    'site.zero_current.discharge':
      "In the inverter's settings the discharge current is 0 A — the battery does not discharge. Change it in DeyeCloud: Battery Setting.",
    'site.zero_current.both':
      "In the inverter's settings the charge and discharge currents are 0 A — the battery does not charge or discharge. Change it in DeyeCloud: Battery Setting.",
    'site.currents_by_phage':
      'The battery currents on the inverter were set by Phage (22–23.10.2026), not by the installer. Phage does not change them any more. Grid charging is off until the installer sets their own currents in DeyeCloud: Battery Setting.',
    'site.prog_changed':
      'The program in the inverter was changed by hand ({at}): it is not the one Phage wrote. Phage writes nothing to the inverter until you decide.',
    'site.prog_changed.diff': 'What differs: {change}',
    'site.prog_changed.keep':
      'To keep the inverter’s program, do nothing: Phage does not change it, disconnecting the object does not either.',
    'site.prog_changed.resume': 'Bring back the Phage program',
    'site.prog_changed.resume_sub': 'Phage writes its program over the one set by hand.',
    'site.prog_changed.err': 'Could not bring back the program: {msg}',
    'site.arb.note.off':
      'Internal arbitrage is off: the inverter runs by its original settings saved at connection.',
    'site.arb.note.closed':
      'Phage.Energy access is closed: arbitrage is stopped, today’s program runs to the end of the day.',
    'site.arb.note.pending': 'Arbitrage starts once Phage.Energy access to the station is open.',
    'site.arb.note.noedit':
      'Control did not turn on: the rights in DeyeCloud are «Only view». Change them to «Can edit» or «Can manage» and press «Turn control on» again.',
    'site.arb.control': 'I want control',
    'site.arb.control.howto':
      'For Phage to control the battery: in DeyeCloud — the station → «Overview» → the icon at the top right → «Manage Access» → {name} → the rights «Can edit» (business account) or «Can manage» (personal). Then press «Turn control on».',
    'site.arb.control.on': 'Turn control on',
    'site.arb.note.dam_today':
      'Hour price — day-ahead prices for {date}. The schedule is recalculated every hour by the actual charge.',
    'site.arb.note.dam_old':
      'Hour price — prices of {date}: the day’s prices are not in yet. Once they arrive the schedule is recalculated; then every hour by the actual charge.',
    'site.arb.note.zone2':
      'Hour price — two-zone tariff rates: night 23:00–07:00 — {night}, day 07:00–23:00 — {day} ₴/kWh. The schedule from 00:00 by the zone rates, recalculated every hour by the actual charge.',
    'site.arb.note.zone3':
      'Hour price — three-zone tariff rates: night 23:00–07:00 — {night}, peak 08:00–11:00 and 20:00–22:00 — {peak}, other hours — {half} ₴/kWh. The schedule from 00:00 by the zone rates, recalculated every hour by the actual charge.',
    'site.arb.note.zone_norates':
      'Hour price — the zone tariff rates. The schedule from 00:00 by the zone rates, recalculated every hour by the actual charge.',
    'site.arb.note.fixed':
      'Fixed tariff: no price difference, no schedule — the inverter runs by its original settings saved at connection.',
    'site.arb.note.noplan':
      'No schedule for today yet: the plan needs a consumption profile and hour prices. Until then the inverter runs by its original settings.',
    'site.arb.note.tariff_unset': 'The tariff is not set — choose it in the settings.',
    'site.arb.price.dam': 'Hour price for the plan: day-ahead prices, ₴/kWh',
    'site.arb.price.zone': 'Hour price for the plan: zone tariff, ₴/kWh',
    'site.arb.batt':
      'Battery: plan and actual, kW (up — discharge, down — charge) · battery charge (SOC), % — right scale',
    'site.arb.legend.plan_charge': 'Plan — charge',
    'site.arb.legend.plan_discharge': 'Plan — discharge',
    'site.arb.legend.fact_charge': 'Actual — charge',
    'site.arb.legend.fact_discharge': 'Actual — discharge',
    'site.arb.legend.soc': 'SOC actual',
    'site.arb.legend.windows': 'Deye windows 1–6',
    'site.arb.now': 'now {time}',
    'site.arb.daysum.fact': 'Actual since 00:00: charge',
    'site.arb.daysum.discharge': 'discharge',
    'site.arb.daysum.limits': 'charge limits',
    'site.arb.daysum.noplan': 'No schedule · charge limits',
    'site.tip.window': 'window {n}',
    'site.tip.price': 'Price {v} ₴/kWh',
    'site.tip.plan': 'Plan: {v}',
    'site.tip.fact': 'Actual: {v}',
    'site.tip.future': 'not yet',
    'site.tip.no_data': 'no data',
    'site.tip.charge': 'charge {v} kW',
    'site.tip.discharge': 'discharge {v} kW',
    'site.tip.zero': '0 kW',
    'site.tip.soc': 'SOC {v} %',
    'site.tip.median': 'Profile {v} kW',
    'site.tip.spread': 'Spread {lo}–{hi} kW',
    'site.tip.load': 'Consumed {v} kWh',
    'site.tip.pv': 'PV {v} kWh',

    'site.win.title': 'Inverter schedule: 6 Deye windows',
    'site.win.status.auto': 'Automatic · recalculated at {time} by the actual charge',
    'site.win.status.auto_plain': 'Automatic',
    'site.win.status.manual':
      'Changed manually · automatic recalculation does not overwrite it until the end of the day',
    'site.win.status.draft': 'Unsaved changes',
    'site.win.hint':
      'Drag a boundary between windows on the strip or change a window in the table. Elapsed windows do not change. Deye runs exactly 6 windows a day; the schedule is written to the inverter as a whole and applies to today only. If there is no schedule for the next day, we return the original inverter settings.',
    'site.win.hint_phone':
      "Change a window in the table. Windows already past do not change. Deye runs exactly 6 windows a day; the schedule is written to the inverter whole and holds for today only. Without a schedule for the next day the inverter's original settings are restored.",
    'site.win.save': 'Write to the inverter',
    'site.win.auto': 'Return to automatic',
    'site.win.saved':
      'Written: the schedule applies to the end of the day. The inverter gets it within a minute.',
    'site.win.reset_done': 'Automatic schedule restored.',
    'site.win.err.conflict': 'There is no schedule for today to change.',
    'site.win.err.invalid':
      'The schedule was not accepted: the windows changed while you edited. Return to automatic or reload the page.',
    'site.win.err.no_access': 'Without Phage.Energy access to the station the schedule cannot be written.',
    'site.win.err.power':
      "Window {n}: the power is above {max} kW — the inverter's power within the installer's limits. Lower it.",
    'site.win.err.grid':
      "Window {n}: the grid charge is above the limits — at most {max} kW (the installer's currents, the allowed power less the consumption). Lower it.",
    'site.win.err.no_grid':
      "Window {n}: no grid charge in these hours — the installer's limits (currents, the grid charge switch) or the allowed power do not leave any. Choose another mode.",
    'site.win.err.no_grid_phage':
      'Window {n}: grid charging is off — the battery currents on the inverter were set by Phage, not by the installer.',
    'site.win.err.soc':
      "Window {n}: the SOC threshold is outside the object's charge limits {min}–{max} % — change it.",
    'site.win.col.window': 'Window',
    'site.win.col.time': 'Time',
    'site.win.col.mode': 'Mode',
    'site.win.col.power': 'Power, kW',
    'site.win.col.soc': 'SOC threshold, %',
    'site.win.col.power_short': 'kW',
    'site.win.col.soc_short': 'SOC, %',
    'site.win.mode.grid_charge': 'Grid charge',
    'site.win.mode.self_consumption': 'Self-consumption',
    'site.win.mode.hold': 'Hold charge',
    'site.win.soc.up_to': 'up to',
    'site.win.soc.not_below': 'not below',
    'site.win.soc.hold': 'no discharge',
    'site.win.state.past': 'elapsed',
    'site.win.state.running': 'running',
    'site.win.sub.grid_charge': '{p} kW · up to {soc} %',
    'site.win.sub.self_consumption': 'up to {p} kW · not below {soc} %',
    'site.win.sub.hold': 'no discharge',
    'site.win.aria.seg': 'Window {n}: {mode}, {from}–{to}',
    'site.win.aria.grip': 'Boundary of windows {a} and {b}',
    'site.win.aria.start': 'Start of window {n}',
    'site.win.aria.mode': 'Mode of window {n}',
    'site.win.aria.power': 'Power of window {n}, kW',
    'site.win.aria.soc': 'SOC threshold of window {n}, %',

    'site.pot.title': 'Connection to the VPP',
    'site.pot.intro':
      "In the Phage.Energy virtual power plant the battery sends energy to the grid in expensive hours at day-ahead prices. The estimate uses your object's data for 30 days.",
    'site.pot.window': 'Income potential over 30 days',
    'site.pot.year': 'Scaled to a year',
    'site.pot.sub': '{from}–{to} · days in the calculation {days} · calculated {at}',
    'site.pot.explain':
      'Calculated with the outage reserve of {reserve} %: the battery does not send this charge to the grid. This is the potential of the whole object, before sharing between the client and the company. The client tariff does not affect this calculation.',
    'site.pot.how': 'How it is calculated',
    'site.pot.how_1': "We take the object's last 30 days: consumption by hour and day-ahead prices.",
    'site.pot.how_2':
      'For each day we build two best battery schedules: for your consumption only, and with selling energy to the grid in expensive hours.',
    'site.pot.how_3':
      'The potential is how much cheaper the day with selling is. The sum over 30 days; per year — scaled to 365 days.',
    'site.pot.how_4':
      'Limits as in the settings: charge from the minimum (or the outage reserve) to the maximum, the inverter power; cycle losses 15 %. Grid tariffs are not included yet.',
    'site.pot.apply': 'Apply',
    'site.pot.intro_client':
      'After the application we model how your inverter works in the virtual power plant: when and how it is engaged and what it contributes. When the model is ready, we open your access to it.',
    'site.pot.applied': 'Application submitted {at} · preparing the model',
    'site.pot.apply_err': 'Could not submit the application. Try again.',
    'site.pot.pending': 'Calculated after the history download.',
    'site.pot.no_osr': "No DSO rate for the object's region — the potential is not calculated.",
    'site.pot.no_data': 'No day with a complete profile and day-ahead prices.',
    'site.pot.no_data_load': 'Load above the inverter rating on every day of the window.',

    'site.st.object': 'Object',
    'site.st.name': 'Name',
    'site.st.region': 'Region',
    'site.st.region.pick': 'Choose the region',
    'site.st.osr': 'Distribution system operator (DSO)',
    'site.st.osr.one': 'set by the region',
    'site.st.osr.many': 'the region has several operators — choose yours',
    'site.st.osr.none': 'no DSO rate for this region in the reference yet',
    'site.st.osr.missing': 'not in the list',
    'site.st.battery': 'Battery and inverter',
    'site.st.cap': 'Battery capacity, kWh',
    'site.st.cap_hint': 'from the battery datasheet',
    'site.st.pmax': 'Inverter power, kW',
    'site.st.allowed': 'Allowed connection power, kW',
    'site.st.allowed_hint': 'from the connection agreement',
    'site.st.reserve': 'Outage reserve, %',
    'site.st.reserve_hint':
      'the battery does not discharge below this charge — neither into the consumption nor to the grid: it is kept for an outage',
    'site.st.max_reserve': 'Maximum reserve',
    'site.st.max_reserve_hint':
      'The battery is kept charged to {max} % and does not discharge: all of it is kept for an outage. It is topped up from the grid in the cheapest hours. No saving from arbitrage. With internal arbitrage on, except a fixed tariff.',
    'site.st.ct': 'Current transformer (CT) at the input',
    'site.st.ct.yes': 'Yes',
    'site.st.ct.no': 'No',
    'site.st.ct.unknown': "Don't know",
    'site.st.ct_hint':
      'with it the battery covers the load of the whole object; without it — only the lines on the inverter backup output. «Don’t know» works as without it',
    'site.st.limits': 'Battery charge limits',
    'site.st.socmin': 'Minimum charge, %',
    'site.st.socmax': 'Maximum charge, %',
    'site.st.tariff': 'Tariff',
    'site.st.tariff.aria': 'Electricity tariff',
    'site.st.tariff.dam': 'Day-ahead prices',
    'site.st.tariff.zone2': 'Two-zone',
    'site.st.tariff.zone3': 'Three-zone',
    'site.st.tariff.fixed': 'Fixed',
    'site.st.zone.night': 'Night 23:00–07:00, ₴/kWh',
    'site.st.zone.day': 'Day 07:00–23:00, ₴/kWh',
    'site.st.zone.peak': 'Peak 08:00–11:00, 20:00–22:00, ₴/kWh',
    'site.st.zone.half': 'Other hours, ₴/kWh',
    'site.st.zone.flat': 'Rate, ₴/kWh',
    'site.st.zone.unread': 'The rates entered earlier apply; to change them, enter new ones.',
    'site.st.tnote.dam': 'Hour price — day-ahead prices; the plan is built for each day by its prices.',
    'site.st.tnote.zone': 'The plan is built by the zone rates, for the whole day ahead.',
    'site.st.tnote.fixed':
      'A fixed tariff has no price difference: no schedule, the inverter runs by its original settings. The rate is for the costs in «Money».',
    'site.st.dirty': 'Unsaved changes',
    'site.st.saved': 'Changes saved. The next hourly recalculation of the plan takes the new parameters.',
    'site.st.save_err': 'Changes not saved: {msg}',
    'site.st.err.name': 'Enter a name.',
    'site.st.err.cap': 'Capacity is a number above 0, kWh.',
    'site.st.err.pmax': 'Power is a number above 0, kW.',
    'site.st.err.allowed': 'Allowed power is a number above 0, kW, or empty.',
    'site.st.err.reserve': 'The reserve is from 0 to 90 %.',
    'site.st.err.soc': 'The minimum charge must be below the maximum, 0–100 %.',
    'site.st.err.rate': 'A rate is a number from 0, ₴/kWh.',
    'site.st.err.region': 'Choose the region.',

    'site.inv.title': 'Inverter and access',
    'site.inv.sn': 'Serial number',
    'site.inv.model': 'Model',
    'site.inv.history': 'History',
    'site.inv.hist.done': '{days} days loaded, updated daily',
    'site.inv.hist.loading': 'loading: {done} of {total} days',
    'site.inv.hist.pending': 'queued for download',
    'site.inv.hist.no_access': 'downloaded once Phage.Energy access is open',
    'site.inv.hist.failed': 'download failed, retried automatically in an hour',
    'site.orig.title': 'Original inverter settings',
    'site.orig.saved':
      'Saved {at} — at connection, before any change. We return them when you switch arbitrage off or disconnect the object.',
    'site.orig.none':
      'Not read yet: we read them from the inverter before the first schedule is written; nothing is written until they are saved.',
    'site.orig.mode': 'Work mode',
    'site.orig.tou': 'Time of use schedule (TOU)',
    'site.orig.mode.ZERO_EXPORT_TO_CT': 'zero export, with a current transformer',
    'site.orig.mode.ZERO_EXPORT_TO_LOAD': 'zero export to the backup load',
    'site.orig.mode.SELLING_FIRST': 'selling first',
    'site.orig.tou.on': 'on',
    'site.orig.tou.off': 'off',
    'site.orig.unknown': 'not recorded',
    'site.lim.title': 'Inverter limits',
    'site.lim.read':
      'Set by the installer; Phage never changes them, the schedule runs within them. Read from the inverter {at}; read again before each hourly plan.',
    'site.lim.original':
      'Set by the installer; Phage never changes them, the schedule runs within them. From the original settings saved {at}.',
    'site.lim.none': 'Not read from the inverter yet: the schedule is limited by the inverter power only.',
    'site.lim.charge': 'Max A Charge — battery charge current, A',
    'site.lim.discharge': 'Max A Discharge — battery discharge current, A',
    'site.lim.grid_switch': 'Grid Charge — charge from the grid',
    'site.lim.grid_a': 'Grid charge current (Batt Set2, Grid Charge «A»), A',
    'site.lim.grid_a.program': '{now} now (Phage sets it for a grid charge window); installer {original}',
    'site.lim.volts': 'Battery voltage, V',
    'site.lim.rated': 'Inverter power, kW',
    'site.lim.plan': 'Schedule within these limits',
    'site.lim.plan.value': 'discharge up to {power} kW, charge from the grid up to {grid} kW',
    'site.lim.plan.no_grid': 'discharge up to {power} kW, no charge from the grid',
    'site.lim.changes':
      'Phage changes the schedule windows (time, power, SOC, charge from the grid), the work mode and the grid charge current for a grid charge window. Never Max A Charge, Max A Discharge or the Grid Charge switch.',
    'site.prog.title': 'Inverter schedule now',
    'site.prog.read': 'Read from the inverter {at}.',
    'site.prog.never': 'Not read from the inverter yet.',
    'site.prog.empty': 'DeyeCloud did not return the schedule.',
    'site.prog.col.grid': 'Grid charge',
    'site.prog.yes': 'yes',
    'site.prog.no': 'no',
    'site.prog.refresh': 'Refresh from the inverter',
    'site.prog.next':
      'Next refresh at {time}: DeyeCloud limits sign-ins, so we read at most once in 10 minutes.',
    'site.prog.done': 'Read from the inverter.',
    'site.prog.no_access': 'No Phage.Energy access to the station: the settings cannot be read.',
    'site.off.title': 'Disconnect object',
    'site.off.text':
      'We return the saved inverter settings and stop the control. Then close the access for Phage.Energy in DeyeCloud: station → «Manage Access» → delete {name}.',
    'site.off.ask': 'Disconnect object',
    'site.off.confirm': 'Disconnect «{name}»?',
    'site.off.yes': 'Yes, disconnect',
    'site.off.done': 'Object «{name}» disconnected. The inverter settings are returned, control stopped.',
    'site.off.done_no_access':
      'Object «{name}» disconnected. The inverter settings are not returned: no Phage.Energy access to the station.',
    'site.off.close_access':
      'Now close the access in DeyeCloud: station → «Manage Access» → delete {company}.',
    'site.off.done_plain': 'Object «{name}» disconnected, control stopped.',
    'site.off.failed':
      'Could not return the inverter settings: DeyeCloud did not accept the write. Try later or disconnect without returning them.',
    'site.off.force': 'Disconnect without returning',
  },
  uk: {
    'sites.title': "Об'єкти",
    'sites.add': "Додати об'єкт",
    'sites.empty.title': "Ще немає об'єктів",
    'sites.empty.sub': 'Додайте інвертор Deye за SN з наклейки — вхід у DeyeCloud не потрібен.',
    'site.card.soc': 'заряд',
    'site.card.no_data': 'даних ще немає',

    'site.conn.ok': "На зв'язку",
    'site.conn.ok_at': "На зв'язку · дані на {time}",
    'site.conn.off': "Немає зв'язку з {time}",
    'site.conn.never': 'Даних ще немає',
    'site.conn.pending': 'Очікує доступу',
    'site.conn.closed': 'Доступ закрито',
    'site.conn.noedit': 'Лише перегляд',
    'site.card.pending': 'Очікує доступу Phage.Energy',
    'site.card.closed': 'Доступ Phage.Energy закрито',
    'site.card.noedit': 'Лише перегляд',
    'site.conn.down': 'DeyeCloud не відповідає з {time}',
    'site.connnote.off':
      'Інвертор не передає дані з {time}. Програма, вже записана в інвертор, виконується. Перевірте живлення інвертора й Wi-Fi логера.',
    'site.connnote.never': 'Замірів ще немає: перший надійде за кілька хвилин після підключення.',
    'site.connnote.pending':
      'Ми ще не бачимо цю станцію в акаунті Phage.Energy, тому даних і керування немає. Відкрийте доступ у DeyeCloud: станція → «Manage Access» → «+Add» → «{name}» → «Can edit» або «Can manage».',
    'site.connnote.closed':
      'Доступ для Phage.Energy закрито в DeyeCloud. Завантаження даних і арбітраж зупинено. Без доступу програму в інверторі не змінити: програма на сьогодні діє до кінця доби. Щоб продовжити — відкрийте доступ знову.',
    'site.connnote.noedit':
      'Доступ відкрито з правом «Only view»: дані надходять, розрахунок готовий. Щоб Phage керувала батареєю — «Хочу керувати».',
    'site.connnote.down':
      'DeyeCloud не відповідає з {time}. Повторюємо кожні 5 хвилин. Програма в інверторі виконується.',

    'site.chip.region': 'Область',
    'site.chip.osr': 'ОСР',
    'site.chip.tariff': 'Тариф',
    'site.chip.pv': 'СЕС',
    'site.chip.pv_kw': '{kw} кВт',
    'site.chip.pv_yes': 'є',
    'site.chip.pv_no': 'немає',
    'site.chip.hist': 'Історія',
    'site.chip.arb': 'Внутрішній арбітраж',
    'site.arb.on_short': 'увімкнено',
    'site.arb.off_short': 'вимкнено',
    'site.arb.stopped': 'зупинено',
    'site.tariff.dam': 'за цінами РДН',
    'site.tariff.zone2': 'двозонний',
    'site.tariff.zone3': 'тризонний',
    'site.tariff.fixed': 'фіксований',
    'site.tariff.none': 'не вказано',
    'site.model': '{model} · SN {sn}',
    'site.model.size': 'батарея {cap} кВт·год · інвертор {p} кВт',
    'site.tabs': "Розділи об'єкта",
    'site.tab.overview': 'Огляд',
    'site.tab.settings': 'Налаштування',

    'site.hist.done': '{days} днів завантажено',
    'site.hist.loading': 'завантажуємо: {done} з {total} днів',
    'site.hist.pending': 'у черзі на завантаження',
    'site.hist.few.one': 'мало даних: {n} доба',
    'site.hist.few.few': 'мало даних: {n} доби',
    'site.hist.few.many': 'мало даних: {n} діб',
    'site.hist.few.other': 'мало даних: {n} доби',
    'site.hist.error': 'помилка завантаження',
    'site.histnote.loading':
      "Завантажуємо історію з DeyeCloud: {done} з {total} днів. Профіль споживання і потенціал з'являться, коли буде 30 повних діб.",
    'site.histnote.few.one':
      'Мало даних: {n} повна доба з 30 потрібних. Потенціал зовнішнього арбітражу ще не рахуємо, профіль — за наявними днями.',
    'site.histnote.few.few':
      'Мало даних: {n} повні доби з 30 потрібних. Потенціал зовнішнього арбітражу ще не рахуємо, профіль — за наявними днями.',
    'site.histnote.few.many':
      'Мало даних: {n} повних діб з 30 потрібних. Потенціал зовнішнього арбітражу ще не рахуємо, профіль — за наявними днями.',
    'site.histnote.few.other':
      'Мало даних: {n} повної доби з 30 потрібних. Потенціал зовнішнього арбітражу ще не рахуємо, профіль — за наявними днями.',
    'site.histnote.error':
      'Історію не завантажено: DeyeCloud не відповідає. Повторимо автоматично за годину.',
    'site.histnote.retry': 'Повторити зараз',
    'site.histnote.queued': 'Поставлено в чергу: завантаження почнеться протягом хвилини.',
    'site.histnote.no_access': 'Без доступу Phage.Energy до станції історію не завантажити.',

    'site.now.title': 'Зараз',
    'site.now.at': 'дані на {time}',
    'site.now.last': 'останні дані {time}',
    'site.now.none': 'Замірів ще немає: перший надійде за кілька хвилин після підключення.',
    'site.now.no_access': 'Даних немає: доступ Phage.Energy до станції не відкрито.',
    'site.now.soc': 'Заряд батареї',
    'site.now.soc_min': 'мінімальний заряд {pct} %',
    'site.now.battery': 'Батарея',
    'site.now.grid': 'Мережа',
    'site.now.pv': 'СЕС',
    'site.now.load': 'Споживання',
    'site.now.charge': 'заряд',
    'site.now.discharge': 'розряд',
    'site.now.idle': 'очікування',
    'site.now.buy': 'купівля',
    'site.now.sell': 'віддача',
    'site.now.no_exchange': 'без обміну',
    'site.now.generation': 'генерація',
    'site.now.object_load': "навантаження об'єкта",
    'site.now.no_value': 'немає заміру',
    'site.unit.kw': 'кВт',

    'site.money.title': 'Гроші',
    'site.money.days.one': '{n} день',
    'site.money.days.few': '{n} дні',
    'site.money.days.many': '{n} днів',
    'site.money.days.other': '{n} дня',
    'site.money.sub': '{days} · {from}–{to} · тариф {tariff}',
    'site.money.tariff.zone': '{name}: {rates} ₴/кВт·год',
    'site.money.zone.night': 'ніч',
    'site.money.zone.day': 'день',
    'site.money.zone.peak': 'пік',
    'site.money.zone.half': 'напівпік',
    'site.money.at.night': 'вночі',
    'site.money.at.day': 'вдень',
    'site.money.at.peak': 'у пік',
    'site.money.at.half': 'у напівпік',
    'site.money.actual': 'Витрати на електрику',
    'site.money.arb': 'З внутрішнім арбітражем, розрахунок',
    'site.money.diff': 'Різниця',
    'site.money.arb.model': 'Якби Phage керувала батареєю — модель',
    'site.money.diff.model': 'Потенціал економії',
    'site.money.model.note':
      'Керування вимкнено: це модель за ті самі дні, в межах налаштувань вашого інвертора.',
    'site.arb.model.title': 'Модель за {days}: {from}–{to}',
    'site.arb.model.how': 'Як рахується',
    'site.arb.model.how.load':
      'Споживання — ваше фактичне по годинах за ці дні, з DeyeCloud; воно повторюється з невеликими відхиленнями.',
    'site.arb.model.how.battery':
      'Батарея {capacity} кВт·год, {floor}–{max} %, ККД {etaCharge} × {etaDischarge}; межі інсталятора: розряд до {power} кВт, заряд з мережі до {grid} кВт.',
    'site.arb.model.how.battery_no_grid':
      'Батарея {capacity} кВт·год, {floor}–{max} %, ККД {etaCharge} × {etaDischarge}; межі інсталятора: розряд до {power} кВт, без заряду з мережі.',
    'site.arb.model.how.edges':
      'Старт — фактичний заряд батареї на початку періоду, кінець — фактичний на його кінці; різниця заряду — за середньою ціною останньої доби.',
    'site.money.how.zones': 'куплено {parts}',
    'site.money.how.part': '{kwh} кВт·год {zone} × {rate}',
    'site.money.how.dam': 'куплено {kwh} кВт·год × середня ціна {price} ₴/кВт·год',
    'site.money.how.arb':
      'ті самі {days}, ваше споживання і власне споживання інвертора по годинах, тариф; батарея — за розкладом внутрішнього арбітражу',
    'site.money.fixed': 'Фіксований тариф: внутрішній арбітраж не застосовується.',
    'site.money.pv': 'Економія від СЕС',
    'site.money.how.pv': 'вироблено {produced} − віддано {exported} = {self} кВт·год',
    'site.money.how.pv_dam': ' × середня ціна {price} ₴/кВт·год',
    'site.money.how.diff': 'витрати − розрахунок з внутрішнім арбітражем',
    'site.money.no_rate': 'ставку фіксованого тарифу не вказано',
    'site.money.no_tariff': 'Суми рахуються за вашим тарифом — оберіть його в налаштуваннях',
    'site.money.no_history': "З'явиться після завантаження історії",
    'site.money.no_prices': 'Немає цін РДН за дні історії',
    'site.data.restored':
      'Відновлено годин: {hours} — інвертор не надсилав у них замірів; енергію між замірами розподілено за часом.',
    'site.energy.title': 'Енергія',
    'site.energy.sub': 'повні доби за місцевим часом',
    'site.energy.unit': 'кВт·год',
    'site.energy.day': 'Доба {date}',
    'site.energy.month': '30 днів, повних діб {days}',
    'site.energy.load': 'Спожито',
    'site.energy.pv': 'Вироблено СЕС',
    'site.energy.import': 'Куплено з мережі',
    'site.energy.export': 'Віддано в мережу',
    'site.energy.charge': 'Заряд батареї',
    'site.energy.discharge': 'Розряд батареї',
    'site.energy.none': "Статистика з'явиться після завантаження історії.",
    'site.energy.legend.load': 'Спожито',
    'site.energy.legend.pv': 'СЕС',
    'site.energy.explain':
      "Віддано в мережу — енергія, що пішла з об'єкта в мережу через точку приєднання (лічильник інвертора). Розряд батареї — енергія з батареї в споживання об'єкта.",

    'site.profile.title': 'Профіль споживання',
    'site.profile.edit': 'Скоригувати вручну',
    'site.profile.note.auto':
      "Побудовано автоматично з історії об'єкта: медіана по годинах за {days} днів ({from}–{to}), разом {total} кВт·год на добу. Використовується в плані внутрішнього арбітражу. Перерахунок щодня після завантаження минулої доби.",
    'site.profile.note.manual':
      'Задано вручну: разом {total} кВт·год на добу. Використовується в плані внутрішнього арбітражу замість автоматичного профілю.',
    'site.profile.none': "Профіль з'явиться, коли буде історія споживання. Задати його можна й вручну.",
    'site.profile.legend.median': 'Медіана, кВт',
    'site.profile.legend.manual': 'Задано вручну, кВт',
    'site.profile.legend.spread': 'Розкид днів, 10–90 %',
    'site.profile.edit.sub':
      'Середнє споживання за годину, кВт. Ручні значення діють, доки ви не повернете автоматичний профіль.',
    'site.profile.save': 'Зберегти профіль',
    'site.profile.reset': 'Повернути автоматичний',
    'site.profile.saved': 'Профіль збережено.',
    'site.profile.reset_done': 'Повернуто автоматичний профіль.',
    'site.profile.err': 'Значення — числа від 0, кВт.',
    'site.profile.hour': '{h}',

    'site.arb.title': 'Внутрішній арбітраж',
    'site.arb.on': 'Увімкнено',
    'site.arb.off': 'Вимкнено',
    'site.arb.sub':
      'доба {date} · заряд з мережі в дешеві години, розряд у власне споживання в дорогі; віддачі батареї в мережу немає',
    'site.arb.no_access_disabled': 'Не перемикається без доступу Phage.Energy до станції.',
    'site.arb.no_original':
      'Вихідні налаштування інвертора не збережено — програма в інвертор не записується, доки їх немає.',
    'site.arb.orig_saved': 'Вихідні налаштування інвертора збережено {at} — після вимкнення повернемо їх.',
    'site.arb.what.title': 'Що робитиме установка сьогодні',
    'site.arb.what.charge': 'Заряд від мережі',
    'site.arb.what.discharge': 'Батарея покриває споживання',
    'site.arb.what.reserve': 'Резерв на випадок відключення',
    'site.arb.what.none': 'немає',
    'site.arb.what.soc': 'до {soc} %',
    'site.arb.what.max_reserve': 'максимальний — {soc} %',
    'site.arb.switch_err': 'Не вдалося перемкнути: {msg}',
    'site.zero_current.charge':
      'У налаштуваннях інвертора струм заряду 0 А — батарея не заряджається. Змініть у DeyeCloud: Battery Setting.',
    'site.zero_current.discharge':
      'У налаштуваннях інвертора струм розряду 0 А — батарея не розряджається. Змініть у DeyeCloud: Battery Setting.',
    'site.zero_current.both':
      'У налаштуваннях інвертора струм заряду і розряду 0 А — батарея не заряджається і не розряджається. Змініть у DeyeCloud: Battery Setting.',
    'site.currents_by_phage':
      'Струми батареї в інверторі встановила Phage (22–23.10.2026), а не інсталятор. Phage їх більше не змінює. Заряд від мережі вимкнено, доки інсталятор не виставить свої струми в DeyeCloud: Battery Setting.',
    'site.prog_changed':
      'Програму в інверторі змінено вручну ({at}): вона не та, що записала Phage. Phage нічого не записує в інвертор, доки ви не вирішите.',
    'site.prog_changed.diff': 'Що відрізняється: {change}',
    'site.prog_changed.keep':
      'Щоб залишити програму інвертора, нічого не робіть: Phage її не змінює, відключення об’єкта теж.',
    'site.prog_changed.resume': 'Повернути програму Phage',
    'site.prog_changed.resume_sub': 'Phage запише свою програму замість встановленої вручну.',
    'site.prog_changed.err': 'Не вдалося повернути програму: {msg}',
    'site.arb.note.off':
      'Внутрішній арбітраж вимкнено: інвертор працює за початковими налаштуваннями, збереженими під час підключення.',
    'site.arb.note.closed':
      'Доступ Phage.Energy закрито: арбітраж зупинено, програма на сьогодні діє до кінця доби.',
    'site.arb.note.pending': 'Арбітраж почнеться, коли відкриєте доступ Phage.Energy до станції.',
    'site.arb.note.noedit':
      'Керування не ввімкнулося: у DeyeCloud права «Only view». Змініть їх на «Can edit» або «Can manage» й натисніть «Увімкнути керування» ще раз.',
    'site.arb.control': 'Хочу керувати',
    'site.arb.control.howto':
      'Щоб Phage керувала батареєю: у DeyeCloud — станція → «Overview» → значок угорі праворуч → «Manage Access» → {name} → права «Can edit» (бізнес-акаунт) або «Can manage» (особистий). Потім натисніть «Увімкнути керування».',
    'site.arb.control.on': 'Увімкнути керування',
    'site.arb.note.dam_today':
      'Ціна години — ціни РДН на {date}. Розклад щогодини перераховується за фактичним зарядом.',
    'site.arb.note.dam_old':
      'Ціна години — ціни {date} — ціни доби ще не отримано. Коли вони надійдуть, розклад перерахуємо; далі — щогодини за фактичним зарядом.',
    'site.arb.note.zone2':
      'Ціна години — ставки двозонного тарифу: ніч 23:00–07:00 — {night}, день 07:00–23:00 — {day} ₴/кВт·год. Розклад з 00:00 за ставками зон, перераховується щогодини за фактичним зарядом.',
    'site.arb.note.zone3':
      'Ціна години — ставки тризонного тарифу: ніч 23:00–07:00 — {night}, пік 08:00–11:00 і 20:00–22:00 — {peak}, решта — {half} ₴/кВт·год. Розклад з 00:00 за ставками зон, перераховується щогодини за фактичним зарядом.',
    'site.arb.note.zone_norates':
      'Ціна години — ставки зонного тарифу. Розклад з 00:00 за ставками зон, перераховується щогодини за фактичним зарядом.',
    'site.arb.note.fixed':
      'Фіксований тариф: різниці цін немає, розкладу немає — інвертор працює за початковими налаштуваннями, збереженими під час підключення.',
    'site.arb.note.noplan':
      'Розкладу на сьогодні ще немає: для плану потрібні профіль споживання й ціни години. До того інвертор працює за початковими налаштуваннями.',
    'site.arb.note.tariff_unset': 'Тариф не вказано — оберіть його в «Налаштуваннях».',
    'site.arb.price.dam': 'Ціна години для плану: ціни РДН, ₴/кВт·год',
    'site.arb.price.zone': 'Ціна години для плану: зонний тариф, ₴/кВт·год',
    'site.arb.batt':
      'Батарея: план і факт, кВт (вгору — розряд, вниз — заряд) · заряд батареї (SOC), % — шкала праворуч',
    'site.arb.legend.plan_charge': 'План — заряд',
    'site.arb.legend.plan_discharge': 'План — розряд',
    'site.arb.legend.fact_charge': 'Факт — заряд',
    'site.arb.legend.fact_discharge': 'Факт — розряд',
    'site.arb.legend.soc': 'SOC факт',
    'site.arb.legend.windows': 'Вікна Deye 1–6',
    'site.arb.now': 'зараз {time}',
    'site.arb.daysum.fact': 'Факт з 00:00: заряд',
    'site.arb.daysum.discharge': 'розряд',
    'site.arb.daysum.limits': 'межі заряду',
    'site.arb.daysum.noplan': 'Розкладу немає · межі заряду',
    'site.tip.window': 'вікно {n}',
    'site.tip.price': 'Ціна {v} ₴/кВт·год',
    'site.tip.plan': 'План: {v}',
    'site.tip.fact': 'Факт: {v}',
    'site.tip.future': 'ще не настала',
    'site.tip.no_data': 'немає даних',
    'site.tip.charge': 'заряд {v} кВт',
    'site.tip.discharge': 'розряд {v} кВт',
    'site.tip.zero': '0 кВт',
    'site.tip.soc': 'SOC {v} %',
    'site.tip.median': 'Профіль {v} кВт',
    'site.tip.spread': 'Розкид {lo}–{hi} кВт',
    'site.tip.load': 'Спожито {v} кВт·год',
    'site.tip.pv': 'СЕС {v} кВт·год',

    'site.win.title': 'Розклад інвертора: 6 вікон Deye',
    'site.win.status.auto': 'Автоматичний · перераховано о {time} за фактичним зарядом',
    'site.win.status.auto_plain': 'Автоматичний',
    'site.win.status.manual': 'Змінено вручну · автоматичний перерахунок не перезаписує до кінця доби',
    'site.win.status.draft': 'Є незаписані зміни',
    'site.win.hint':
      'Перетягніть межу між вікнами на смузі або змініть вікно в таблиці. Вікна, що вже минули, не змінюються. Deye виконує рівно 6 вікон на добу; розклад записується в інвертор цілком і діє тільки сьогодні. Якщо на наступну добу розкладу немає, повертаємо початкові налаштування інвертора.',
    'site.win.hint_phone':
      'Змініть вікно в таблиці. Вікна, що вже минули, не змінюються. Deye виконує рівно 6 вікон на добу; розклад записується в інвертор цілком і діє тільки сьогодні. Якщо на наступну добу розкладу немає, повертаємо початкові налаштування інвертора.',
    'site.win.save': 'Записати в інвертор',
    'site.win.auto': 'Повернути автоматичний',
    'site.win.saved': 'Записано: розклад діє до кінця доби. Інвертор отримає його протягом хвилини.',
    'site.win.reset_done': 'Повернуто автоматичний розклад.',
    'site.win.err.conflict': 'Розкладу на сьогодні немає — змінювати нічого.',
    'site.win.err.invalid':
      'Розклад не прийнято: вікна змінилися, поки ви редагували. Поверніть автоматичний або оновіть сторінку.',
    'site.win.err.no_access': 'Без доступу Phage.Energy до станції розклад не записати.',
    'site.win.err.power':
      'Вікно {n}: потужність більша за {max} кВт — потужність інвертора в межах налаштувань інсталятора. Зменште її.',
    'site.win.err.grid':
      'Вікно {n}: заряд від мережі більший за межі — не більше {max} кВт (струми інсталятора, дозволена потужність мінус споживання). Зменште його.',
    'site.win.err.no_grid':
      'Вікно {n}: заряд від мережі в ці години неможливий — його не дозволяють налаштування інсталятора (струми, перемикач заряду від мережі) або дозволена потужність. Виберіть інший режим.',
    'site.win.err.no_grid_phage':
      'Вікно {n}: заряд від мережі вимкнено — струми батареї в інверторі встановила Phage, а не інсталятор.',
    'site.win.err.soc': "Вікно {n}: поріг SOC поза межами заряду об'єкта {min}–{max} % — змініть його.",
    'site.win.col.window': 'Вікно',
    'site.win.col.time': 'Час',
    'site.win.col.mode': 'Режим',
    'site.win.col.power': 'Потужність, кВт',
    'site.win.col.soc': 'Поріг SOC, %',
    'site.win.col.power_short': 'кВт',
    'site.win.col.soc_short': 'SOC, %',
    'site.win.mode.grid_charge': 'Заряд з мережі',
    'site.win.mode.self_consumption': 'Власне споживання',
    'site.win.mode.hold': 'Утримання заряду',
    'site.win.soc.up_to': 'до',
    'site.win.soc.not_below': 'не нижче',
    'site.win.soc.hold': 'не розряджати',
    'site.win.state.past': 'минуло',
    'site.win.state.running': 'триває',
    'site.win.sub.grid_charge': '{p} кВт · до {soc} %',
    'site.win.sub.self_consumption': 'до {p} кВт · не нижче {soc} %',
    'site.win.sub.hold': 'без розряду',
    'site.win.aria.seg': 'Вікно {n}: {mode}, {from}–{to}',
    'site.win.aria.grip': 'Межа вікон {a} і {b}',
    'site.win.aria.start': 'Початок вікна {n}',
    'site.win.aria.mode': 'Режим вікна {n}',
    'site.win.aria.power': 'Потужність вікна {n}, кВт',
    'site.win.aria.soc': 'Поріг SOC вікна {n}, %',

    'site.pot.title': 'Підключення до VPP',
    'site.pot.intro':
      "У віртуальній електростанції Phage.Energy батарея віддає енергію в мережу в дорогі години за цінами РДН. Оцінка — на даних вашого об'єкта за 30 днів.",
    'site.pot.window': 'Потенціал доходу за 30 днів',
    'site.pot.year': 'Перерахунок на рік',
    'site.pot.sub': '{from}–{to} · діб у розрахунку {days} · розраховано {at}',
    'site.pot.explain':
      "Розраховано з резервом на відключення {reserve} %: цей заряд батарея в мережу не віддає. Це потенціал об'єкта цілком, до розподілу між клієнтом і компанією. Тариф клієнта на цей розрахунок не впливає.",
    'site.pot.how': 'Як рахується',
    'site.pot.how_1': "Беремо останні 30 діб вашого об'єкта: споживання по годинах і ціни РДН.",
    'site.pot.how_2':
      'Для кожної доби складаємо два найкращі розклади батареї: лише на ваше споживання — і з продажем енергії в мережу в дорогі години.',
    'site.pot.how_3':
      'Потенціал — наскільки дешевша доба з продажем у мережу. Сума за 30 днів; на рік — у перерахунку на 365 днів.',
    'site.pot.how_4':
      'Межі ті самі, що в налаштуваннях: заряд від мінімального (або резерву на відключення) до максимального, потужність інвертора; втрати на циклі 15 %. Тарифи мережі поки не враховані.',
    'site.pot.apply': 'Подати заявку',
    'site.pot.intro_client':
      'Після заявки ми змоделюємо роботу вашого інвертора у віртуальній електростанції: коли і як він задіюється та який внесок дає. Коли модель буде готова, ми відкриємо вам доступ до неї.',
    'site.pot.applied': 'Заявку подано {at} · модель готуємо',
    'site.pot.apply_err': 'Не вдалося подати заявку. Спробуйте ще раз.',
    'site.pot.pending': 'Розраховується після завантаження історії.',
    'site.pot.no_osr': "Немає ставки ОСР для області об'єкта — потенціал не розраховується.",
    'site.pot.no_data': 'Немає діб із повним профілем і цінами РДН.',
    'site.pot.no_data_load': 'Навантаження перевищує номінал інвертора в усі доби вікна.',

    'site.st.object': "Об'єкт",
    'site.st.name': 'Назва',
    'site.st.region': 'Область',
    'site.st.region.pick': 'Оберіть область',
    'site.st.osr': 'Оператор розподілу (ОСР)',
    'site.st.osr.one': 'визначається за областю',
    'site.st.osr.many': 'в області кілька операторів — оберіть свого',
    'site.st.osr.none': 'для цієї області ще немає ставки ОСР у довіднику',
    'site.st.osr.missing': 'немає в довіднику',
    'site.st.battery': 'Батарея й інвертор',
    'site.st.cap': 'Ємність батареї, кВт·год',
    'site.st.cap_hint': 'з паспорта батареї',
    'site.st.pmax': 'Потужність інвертора, кВт',
    'site.st.allowed': 'Дозволена потужність, кВт',
    'site.st.allowed_hint': 'з договору про приєднання',
    'site.st.reserve': 'Резерв на відключення, %',
    'site.st.reserve_hint':
      'нижче цього заряду батарея не розряджається — ні у споживання, ні в мережу: він тримається на випадок відключення',
    'site.st.max_reserve': 'Максимальний резерв',
    'site.st.max_reserve_hint':
      'Батарея тримається зарядженою до {max} % і не розряджається: уся ємність — на випадок відключення. Дозаряд від мережі — у найдешевші години. Економії від арбітражу не буде. Діє з увімкненим внутрішнім арбітражем, крім фіксованого тарифу.',
    'site.st.ct': 'Трансформатор струму (CT) на вводі',
    'site.st.ct.yes': 'Є',
    'site.st.ct.no': 'Немає',
    'site.st.ct.unknown': 'Не знаю',
    'site.st.ct_hint':
      "з ним батарея покриває споживання всього об'єкта; без нього — лише лінії на виході резерву інвертора. «Не знаю» — працюємо як без нього",
    'site.st.limits': 'Межі заряду батареї',
    'site.st.socmin': 'Мінімальний заряд, %',
    'site.st.socmax': 'Максимальний заряд, %',
    'site.st.tariff': 'Тариф',
    'site.st.tariff.aria': 'Тариф на електроенергію',
    'site.st.tariff.dam': 'За цінами РДН',
    'site.st.tariff.zone2': 'Двозонний',
    'site.st.tariff.zone3': 'Тризонний',
    'site.st.tariff.fixed': 'Фіксований',
    'site.st.zone.night': 'Ніч 23:00–07:00, ₴/кВт·год',
    'site.st.zone.day': 'День 07:00–23:00, ₴/кВт·год',
    'site.st.zone.peak': 'Пік 08:00–11:00, 20:00–22:00, ₴/кВт·год',
    'site.st.zone.half': 'Решта годин, ₴/кВт·год',
    'site.st.zone.flat': 'Ставка, ₴/кВт·год',
    'site.st.zone.unread': 'Ставки, введені раніше, діють; щоб змінити — введіть нові.',
    'site.st.tnote.dam': 'Ціна години — ціни РДН; план будуємо на кожну добу за її цінами.',
    'site.st.tnote.zone': 'План будуємо за ставками зон, наперед на всю добу.',
    'site.st.tnote.fixed':
      'При фіксованому тарифі різниці цін немає: розкладу немає, інвертор працює за початковими налаштуваннями. Ставка — для витрат у «Гроші».',
    'site.st.dirty': 'Є незбережені зміни',
    'site.st.saved': 'Зміни збережено. Наступний щогодинний перерахунок плану врахує нові параметри.',
    'site.st.save_err': 'Зміни не збережено: {msg}',
    'site.st.err.name': 'Вкажіть назву.',
    'site.st.err.cap': 'Ємність — число більше 0, кВт·год.',
    'site.st.err.pmax': 'Потужність — число більше 0, кВт.',
    'site.st.err.allowed': 'Дозволена потужність — число більше 0, кВт, або порожньо.',
    'site.st.err.reserve': 'Резерв — від 0 до 90 %.',
    'site.st.err.soc': 'Мінімальний заряд має бути менший за максимальний, 0–100 %.',
    'site.st.err.rate': 'Ставка — число від 0, ₴/кВт·год.',
    'site.st.err.region': 'Оберіть область.',

    'site.inv.title': 'Інвертор і доступ',
    'site.inv.sn': 'Серійний номер',
    'site.inv.model': 'Модель',
    'site.inv.history': 'Історія',
    'site.inv.hist.done': '{days} днів завантажено, оновлюється щодня',
    'site.inv.hist.loading': 'завантажуємо: {done} з {total} днів',
    'site.inv.hist.pending': 'у черзі на завантаження',
    'site.inv.hist.no_access': 'завантажимо, коли відкриєте доступ Phage.Energy',
    'site.inv.hist.failed': 'помилка завантаження, повтор автоматично за годину',
    'site.orig.title': 'Початкові налаштування інвертора',
    'site.orig.saved':
      "Збережено {at} — під час підключення, до будь-яких змін. Повернемо їх, коли вимкнете арбітраж або відключите об'єкт.",
    'site.orig.none':
      'Ще не прочитано: прочитаємо з інвертора перед першим записом розкладу; доки їх не збережено, нічого не записуємо.',
    'site.orig.mode': 'Режим роботи',
    'site.orig.tou': 'Розклад за часом (TOU)',
    'site.orig.mode.ZERO_EXPORT_TO_CT': 'нульовий експорт, з трансформатором струму',
    'site.orig.mode.ZERO_EXPORT_TO_LOAD': 'нульовий експорт, на навантаження резерву',
    'site.orig.mode.SELLING_FIRST': 'пріоритет продажу в мережу',
    'site.orig.tou.on': 'увімкнено',
    'site.orig.tou.off': 'вимкнено',
    'site.orig.unknown': 'не записано',
    'site.lim.title': 'Ліміти інвертора',
    'site.lim.read':
      'Встановлює інсталятор; Phage їх не змінює, розклад працює в їхніх межах. Прочитано з інвертора {at}; перечитуємо перед кожним погодинним планом.',
    'site.lim.original':
      'Встановлює інсталятор; Phage їх не змінює, розклад працює в їхніх межах. За початковими налаштуваннями, збереженими {at}.',
    'site.lim.none': 'Ще не прочитано з інвертора: розклад обмежено лише потужністю інвертора.',
    'site.lim.charge': 'Max A Charge — струм заряду батареї, А',
    'site.lim.discharge': 'Max A Discharge — струм розряду батареї, А',
    'site.lim.grid_switch': 'Grid Charge — заряд з мережі',
    'site.lim.grid_a': 'Струм заряду з мережі (Batt Set2, Grid Charge «A»), А',
    'site.lim.grid_a.program':
      '{now} зараз (Phage ставить під вікно заряду з мережі); інсталятор — {original}',
    'site.lim.volts': 'Напруга батареї, В',
    'site.lim.rated': 'Потужність інвертора, кВт',
    'site.lim.plan': 'Розклад у цих межах',
    'site.lim.plan.value': 'розряд до {power} кВт, заряд з мережі до {grid} кВт',
    'site.lim.plan.no_grid': 'розряд до {power} кВт, без заряду з мережі',
    'site.lim.changes':
      'Phage змінює вікна розкладу (час, потужність, SOC, заряд з мережі), режим роботи і струм заряду з мережі під вікно заряду. Не змінює Max A Charge, Max A Discharge і перемикач Grid Charge.',
    'site.prog.title': 'Розклад в інверторі зараз',
    'site.prog.read': 'Прочитано з інвертора {at}.',
    'site.prog.never': 'Ще не прочитано з інвертора.',
    'site.prog.empty': 'DeyeCloud не віддав розклад.',
    'site.prog.col.grid': 'Заряд з мережі',
    'site.prog.yes': 'так',
    'site.prog.no': 'ні',
    'site.prog.refresh': 'Оновити з інвертора',
    'site.prog.next':
      'Наступне оновлення о {time}: DeyeCloud обмежує частоту входу, тому читаємо не частіше разу на 10 хвилин.',
    'site.prog.done': 'Прочитано з інвертора.',
    'site.prog.no_access': 'Немає доступу Phage.Energy до станції: налаштування не прочитати.',
    'site.off.title': "Відключити об'єкт",
    'site.off.text':
      'Повернемо збережені налаштування інвертора й зупинимо керування. Потім закрийте доступ для Phage.Energy у DeyeCloud: станція → «Manage Access» → видаліть {name}.',
    'site.off.ask': "Відключити об'єкт",
    'site.off.confirm': 'Відключити «{name}»?',
    'site.off.yes': 'Так, відключити',
    'site.off.done': "Об'єкт «{name}» відключено. Налаштування інвертора повернуто, керування зупинено.",
    'site.off.done_no_access':
      "Об'єкт «{name}» відключено. Налаштування інвертора не повернуто: немає доступу Phage.Energy до станції.",
    'site.off.close_access':
      'Тепер закрийте доступ у DeyeCloud: станція → «Manage Access» → видаліть {company}.',
    'site.off.done_plain': "Об'єкт «{name}» відключено, керування зупинено.",
    'site.off.failed':
      'Не вдалося повернути налаштування інвертора: DeyeCloud не прийняв запис. Спробуйте пізніше або відключіть без повернення.',
    'site.off.force': "Від'єднати без повернення",
  },
} as const;
